import React, { useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { faCaretLeft, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useHome from '../../context/useHome';
import { useNavigate, useParams } from 'react-router-dom';
import config from '../../../../config';
import homeLogo from '../../../../assets/images/header/logo.png'
import { setThemeStorage } from '../../../../utils/localStorage';
import { rmSearchHistoryStorage } from '../../../../utils/localStorage';

const Carousel = () => {
    const { orgUnitIdContext, setOrgUnitIdContext, cards, query } = useHome()
    const sliderRef = useRef(null);
    const { org } = useParams()
    const history = useNavigate()

    useEffect(() => {
        if (org && cards) {
            const _org = cards.find(item => item.orgUnitName === org)
            if (_org) {
                setOrgUnitIdContext(_org.orgUnitId)
            }
        }

        if (!org) {
            setThemeStorage('red')
        }
    }, [cards, query.fetchHome])

    const ArrowLeft = ({ currentSlide, slideCount, ...props }) => (
        <button
            {...props}
            aria-hidden="true"
            aria-disabled={currentSlide === 0 ? true : false}>
            <FontAwesomeIcon icon={faCaretLeft} className={(currentSlide === 0 ? 'icon-disabled' : '')} />
        </button>
    );
    const ArrowRight = ({ currentSlide, slideCount, ...props }) => (
        <button
            {...props}
            aria-hidden="true"
            aria-disabled={props.className.includes('slick-disabled') ? true : false}
        >
            <FontAwesomeIcon
                icon={faCaretRight}
                className={(props.className.includes('slick-disabled') ? 'icon-disabled' : '')} />
        </button>
    );

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 6,
        prevArrow: <ArrowLeft />,
        nextArrow: <ArrowRight />,
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 780,
                settings: {
                    arrows: false,
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    arrows: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 4
                },
            },
        ]
    };

    const handleClickCard = (orgUnitId, orgUnitName) => {
        rmSearchHistoryStorage()
        history(`/${orgUnitName}`)
        setOrgUnitIdContext(orgUnitId)
    }

    const Card = ({ id, orgUnitName, logo, orgUnitId }) => (
        <div className={`div-card relative cursor-pointer ${orgUnitIdContext === orgUnitId ? 'card-selected' : ''}`}
            onClick={() => handleClickCard(orgUnitId, orgUnitName)}>
            <div className={`card flex justify-center`}>
                <img src={logo ? `${config.wfAttachFileEndPoint}/${logo}` : homeLogo} alt={orgUnitName ?? ''} />
                <div className="card-title line-clamp-2">{orgUnitName ?? ''}</div>
            </div>
            <div className="card-footer"></div>
        </div>
    );

    return (
        <div className='scope1-carousel container margin-auto'>
            <div className="carousel-wrapper">
                {cards && cards.length > 0 &&
                    <Slider ref={sliderRef} {...settings}>
                        {cards.map((card, index) => (
                            <Card key={index} {...card} />
                        ))}
                    </Slider>
                }
            </div>
        </div>
    );
};

export default Carousel;
